import { render } from "./ForemanIcon.vue?vue&type=template&id=6f415b5a&ts=true&lang=pug"
import script from "./ForemanIcon.vue?vue&type=script&lang=ts"
export * from "./ForemanIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__